// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E6bc","content":"styles_content__mhaU5"};